export default "__VITE_ASSET__85806d77__"